import { createIcon } from '@chakra-ui/react'

const IconSparkle = createIcon({
  displayName: 'IconSparkle',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: '12px'
  },
  path: (
    <path
      d="M8 0C8 0 9.5 5.5 10 6C10.5 6.5 16 8 16 8C16 8 10.5 9.5 10 10C9.5 10.5 8 16 8 16C8 16 6.5 10.5 6 10C5.5 9.5 0 8 0 8C0 8 5.5 6.5 6 6C6.5 5.5 8 0 8 0Z"
      fill="currentColor"
    />
  )
})

export default IconSparkle
